export default __webpack_public_path__ + "static/media/gia-table@2x.ac99821c.png";